const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('hostButtons', ['Application', function (Application) {
  return {
    restrict: "A",
    scope: {
    },
    link: function(scope, element, attrs) {
      element.bind('click', function() {
        var url = Application.navigation.getUrl();
        var contentId;
        if (!/view/g.test(url)) {
          return;
        }
        var splitUrl = url.split('/');

        // tracks must be first as it may contain other types in the url
        if (/tracks/g.test(url)) {
          for (var i = 0; i < splitUrl.length; i++) {
            if (splitUrl[i] === 'tracks') {
              contentId = splitUrl[i + 1];
              Application.navigation.goToTab('/host/track/' + contentId);
              scope.$apply();
              return;
            }
          }
          return;
        }
        contentId = splitUrl[splitUrl.length - 1];
        if (contentId && contentId.indexOf('?') !== -1) {
          contentId = contentId.split('?')[0];
        }
        if (/articles/g.test(url)) {
          Application.navigation.goToTab('/host/articles/' + contentId);     
          scope.$apply();
          return;
        }
        if (/videos/g.test(url)) {
          Application.navigation.goToTab('/host/videos/' + contentId);
          scope.$apply();
          return;
        }
        if (/files/g.test(url)) {
          Application.navigation.goToTab('/host/files/' + contentId);
          scope.$apply();
          return;
        }
        if (/events/g.test(url)) {
          Application.navigation.goToTab('/host/events/' + contentId);
          scope.$apply();
          return;
        }
        if (/workshops/g.test(url)) {
          if (/multi-session/g.test(url)) {
            Application.navigation.goToTab('/host/multi-session-workshops/' + contentId);
          } else {
            Application.navigation.goToTab('/host/workshops/' + contentId);
          }
          scope.$apply();
          return;
        }
        if (/imported-content/g.test(url)) {
          Application.navigation.goToTab('/host/imported-content/' + contentId);
          scope.$apply();
          return;
        }
        if (/scorm/g.test(url)) {
          Application.navigation.goToTab('/host/scorm/' + contentId);
          scope.$apply();
          return;
        }
      });
    }
  }
}]);